module.exports = "<div ng-if=\"loading\" id=\"spinner\" class=\"spinner\">\n    <div class=\"spinWrap\">\n        <p class=\"spinnerImage\"></p>\n        <p class=\"loader\"></p>\n        <p id=\"spinner-message\" tabIndex=\"0\" class=\"loadingMessage\">{{message}}</p>\n    </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ../~/noop-loader!./components/xo-ui-components/src/spinner/template.html
// module id = ../node_modules/noop-loader/index.js!./components/xo-ui-components/src/spinner/template.html
// module chunks = 1